<template>
  <Layout background-color="#e3e9ea" active="report" hide-logout="true" title="Reports">

    <template v-slot:main-btn>
      <div class="level-right">
        <router-link :to="{'name': 'calculator'}"
                     class="button is-primary">
          New Valuation
        </router-link>
<!--        <upgrade-action redirect-to="new-valuation">-->
<!--          <button v-if="!hasCredits" class="button is-primary">-->
<!--            Upgrade-->
<!--          </button>-->
<!--        </upgrade-action>-->
      </div>
    </template>

    <div class="columns" style="flex-wrap: wrap;">

      <div class="column" v-if="loading">
        Loading
      </div>
      <div class="column" v-if="reports.length === 0 && !loading">
        No reports found.
      </div>
      <div class="column is-4" v-for="report in reports">
        <div class="report-item">
          <div class="report-item-icon">

          </div>
          <div class="sep-16"></div>
          <div class="report-item-date">{{ report.created | moment("YYYY-MM-DD") }}</div>
          <div class="sep-8"></div>
          <div class="report-item-valuation"  v-if="report.status === 'unlocked'">{{ report.avg_valuation|formatDollarsNoZeros }}</div>
          <div class="sep-8"  v-if="report.status === 'unlocked'"></div>
          <div class="report-item-company-name">{{ report.startup_name || '--' }}</div>
          <div class="sep-8"></div>
          <upgrade-action v-if="report.status !== 'unlocked'">
            <button to="#" class="button is-outlined is-fullwidth">
              Download Report
            </button>
          </upgrade-action>
          <button @click="downloadReport(report.id)" v-if="report.status === 'unlocked'" class="button is-outlined is-fullwidth"
                  :class="{'is-loading': !report.is_report_ready}">
            Download Report
          </button>
        </div>
      </div>

    </div>
  </Layout>
</template>

<script>
import Layout from "../../../shared/components/Layout";
import {ReportAPI} from "../../../apis/ReportAPI";
import {mapGetters} from "vuex";
import UpgradeAction from "@/shared/components/UpgradeAction";
import CalculatorMixin from "@/modules/calculator/mixins";

export default {
  name: "Reports.vue",
  mixins: [CalculatorMixin],
  components: {
    Layout,
    UpgradeAction
  },
  data() {
    return {
      'reports': [],
      'loading': false
    }
  },
  async mounted() {
    this.loading = true;
    let resp = await ReportAPI.listPDFReports();
    this.reports = resp.list;
    this.loading = false;
    SFAnalytics.track('Dashboard Reports Page Viewed');
  },
  methods: {
  },
  computed: {
    ...mapGetters('account', [
      'hasCredits',
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/utils";
@import "../../../style/mixins";

.report-item {
  border-radius: 4px;
  padding: 24px;
  min-height: 340px;
  width: 100%;
  background-color: #fff;
  //@include respond-to('mdp') {
  //  width: 300px;
  //}

  .report-item-icon {
    height: 160px;
    width: 100%;
    border: 1px solid #E3E9EA;
    border-radius: 4px;
    background-color: rgba(227, 233, 234, 0.5);
    background-repeat: no-repeat;
    background-image: url(../../../images/icons/pdf.svg);
    background-position: center;
    background-size: 90px;
  }

  .report-item-date {
    color: #7C828A;
  }

  .report-item-valuation {
    font-size: 22px;
    @extend .font-bold;
  }

  .report-item-company-name {
    color: #4E5963;
    font-size: 18px;
  }
}
</style>
